import React from "react";
import { Route, Routes, useLocation, Navigate } from "react-router";
import HomePage from "@/src/containers/Pages/Generic/HomePage/HomePage";
import Error404Page from "@/src/containers/Pages/Generic/Error404/Error404Page";
import AdminPage from "@/src/containers/Pages/Generic/AdminPage/AdminPage";
import LoginPage from "@/src/containers/Pages/Generic/LoginPage/LoginPage";
import RegisterPage from "@/src/containers/Pages/Generic/RegisterPage/RegisterPage";
import SmsRegistrationPage from "@/src/containers/Pages/Generic/SmsRegistrationPage/SmsRegistrationPage";
import PasswordPage from "@/src/containers/Pages/Generic/PasswordPage/PasswordPage";
import NewEmailPage from "@/src/containers/Pages/Generic/NewEmailPage/NewEmailPage";
import ImprintPage from "@/src/containers/Pages/Generic/ImprintPage/ImprintPage";
import TermsOfServiceLegalbirdOSPage from "@/src/containers/Pages/Generic/TermsOfService/TermsOfServiceLegalbirdOSPage/TermsOfServiceLegalbirdOSPage";
import PrivacyLegalbirdOSPage from "@/src/containers/Pages/Generic/PrivacyLegalbirdOSPage/PrivacyLegalbirdOSPage";
import AboutUsPage from "@/src/containers/Pages/Generic/AboutUsPage/AboutUsPage";
import TermsOfServiceLawFirmPage from "@/src/containers/Pages/Generic/TermsOfService/TermsOfServiceLawFirmPage/TermsOfServiceLawFirmPage";
import PrivacyLawFirmPage from "@/src/containers/Pages/Generic/PrivacyLawFirmPage/PrivacyLawFirmPage";
import TermsOfServiceLegalbirdFinancingPage from "@/src/containers/Pages/Generic/TermsOfService/TermsOfServiceLegalbirdFinancingPage/TermsOfServiceLegalbirdFinancingPage";
import CookiePolicyPage from "@/src/containers/Pages/CookiePolicy/CookiePolicyPage";
import ContactPage from "@/src/containers/Pages/Generic/ContactPage/ContactPage";
import LegalFieldPage from "@/src/containers/Pages/LegalFieldPage/LegalFieldPage";
import useTracker from "@/src/services/useTracker";
import AccountDeletionPage from "@/src/containers/Pages/Generic/AccountDeletionPage/AccountDeletionPage";
import A11yStatementPage from "@/src/containers/Pages/Generic/A11yStatementPage/A11yStatementPage";

export default function Base() {
  useTracker();
  const { search } = useLocation();

  return (
    <Routes>
      <Route path={"familienrecht"} element={<LegalFieldPage productCategory={"familyLaw"} />} />
      <Route path={"arbeitsrecht"} element={<LegalFieldPage productCategory={"employmentLaw"} />} />
      <Route path={"verkehrsrecht"} element={<LegalFieldPage productCategory={"trafficLaw"} />} />
      <Route path={"vertragsrecht"} element={<LegalFieldPage productCategory={"contractLaw"} />} />
      <Route path={"mietrecht"} element={<LegalFieldPage productCategory={"tenancyLaw"} />} />
      <Route path={"allgemeines-zivilrecht"} element={<LegalFieldPage productCategory={"civilLaw"} />} />
      <Route path={"papageienaufstand"} element={<AdminPage />} />
      <Route path={"impressum"} element={<ImprintPage />} />
      <Route path={"agb"} element={<TermsOfServiceLawFirmPage />} />
      <Route path={"agb-legalbird"} element={<TermsOfServiceLegalbirdOSPage />} />
      <Route path={"agb-prozessfinanzierung"} element={<TermsOfServiceLegalbirdFinancingPage />} />
      <Route path={"datenschutz"} element={<PrivacyLawFirmPage />} />
      <Route path={"datenschutz-legalbird"} element={<PrivacyLegalbirdOSPage />} />
      <Route path={"cookierichtlinie"} element={<CookiePolicyPage />} />
      <Route path={"barrierefreiheit"} element={<A11yStatementPage />} />
      <Route path={"ueber-uns"} element={<AboutUsPage />} />
      <Route path={"kontakt"} element={<ContactPage />} />
      <Route path={"login"} element={<LoginPage />} />
      <Route path={"konto-loeschen"} element={<AccountDeletionPage />} />
      <Route path={"registrierung"} element={<RegisterPage />} />
      <Route path={"registrierung/sms"} element={<SmsRegistrationPage />} />
      <Route path={"neue-email/setzen"} element={<NewEmailPage />} />
      <Route path={"feedback"} element={<Navigate to={`/servicewelt/feedback${search}`} replace={true} />} />
      <Route path={"passwort/*"} element={<PasswordPage />} />
      <Route path={""} element={<HomePage />} />
      <Route path={"*"} element={<Error404Page />} />
    </Routes>
  );
}
